import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from './MetaPixel';
export function FinalCTA() {
  return <section className="bg-primary py-16 md:py-24 px-4 md:px-12" data-id="element-29">
      <div className="max-w-3xl mx-auto text-center" data-id="element-30">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-31">
          <h2 className="font-playfair font-bold text-3xl md:text-5xl text-warm-white mb-4" data-id="element-32">
            El problema no es cuánto ganas…
          </h2>

          <p className="font-inter text-lg md:text-2xl text-warm-muted mb-4" data-id="element-33">
            es cómo tu cuerpo reacciona cuando el dinero aparece.
          </p>

          <p className="font-playfair italic text-xl md:text-3xl text-gold mb-10" data-id="element-34">
            Y eso… se puede cambiar.
          </p>

          <a href="https://pay.hotmart.com/I105463361U?checkoutMode=10" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-block w-full max-w-lg text-center bg-gold hover:bg-gold-light transition-all text-primary font-inter font-bold text-sm md:text-base px-6 py-4 md:py-5 rounded-xl shadow-glow-gold hover:shadow-glow-gold-lg transform hover:-translate-y-1" data-id="element-35">
            QUIERO CAMBIAR MI RELACIÓN CON EL DINERO HOY
          </a>
        </motion.div>
      </div>
    </section>;
}